import React from 'react';
import {View} from 'react-native';
import HotList from '../hot-list/index_next';
import LiveListItem from './live-casino-list-item';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';

interface GameListWithHotListProps {
  item: any[];
  isOld: boolean;
  pageLoading: boolean;
  headerHeight: number;
  scrollY: any;
  index: number;
  gameList?: any[];
  toGame: (params: any) => void;
  theme: any;
}

const GameListWithHotList: React.FC<GameListWithHotListProps> = ({
  item,
  isOld,
  pageLoading,
  headerHeight,
  scrollY,
  index,
  gameList,
  toGame,
  theme,
}) => {
  const {calcActualSize} = useScreenSize();
  // console.log('gameList>>>>', gameList);
  const shouldShowHotList =
    index === 2 ||
    (gameList && gameList?.length <= 2 && index === gameList.length - 1);

  const gameItems = item
    .filter(pie => pie)
    .map((pie, i) => (
      <LiveListItem
        key={i}
        isOld={isOld}
        pageLoading={pageLoading}
        headerHeight={headerHeight}
        scrollY={scrollY}
        index={index}
        onPress={() => {
          toGame({
            source: pie.source,
            name: pie.name,
            id: pie.id,
            gameUrl: pie.gameUrl,
            tripartiteUniqueness: pie.tripartiteUniqueness,
          });
        }}
        gameInfo={pie}
      />
    ));
  // console.log('gameItems>>>>', gameItems, shouldShowHotList);

  if (isOld) {
    return (
      <>
        <View style={[theme.flex.row, theme.padding.lrl, {columnGap: 8}]}>
          {gameItems}
        </View>
        {shouldShowHotList && (
          // <View style={[theme.flex.row, theme.padding.lrl, {columnGap: 8}]}>
          <HotList
            type="LIVE"
            limit={3}
            wrapperClassName={allData =>
              allData && allData.length > 0 ? 'pb-3 gap-2' : ''
            }
          />
          // </View>
        )}
      </>
    );
  }

  return (
    <>
      <View
        style={[
          theme.flex.row,
          {
            paddingHorizontal: calcActualSize(theme.paddingSize.l),
            columnGap: calcActualSize(theme.paddingSize.s),
          },
        ]}>
        {gameItems}
      </View>
      {shouldShowHotList && (
        <View
          style={[
            theme.flex.row,
            // {
            //   //   paddingHorizontal: calcActualSize(theme.paddingSize.l),
            //   columnGap: calcActualSize(theme.paddingSize.s),
            //   paddingBottom: calcActualSize(theme.paddingSize.l),
            // },
          ]}>
          <View style={{flex: 1}}>
            <HotList
              type="LIVE"
              limit={3}
              wrapperClassName={allData =>
                allData && allData.length > 0 ? 'pb-3 gap-2' : ''
              }
            />
          </View>
        </View>
      )}
    </>
  );
};

export default GameListWithHotList;
